<template>
	<div class="page page-testInner page-test">

		<transition-group name="fadeIn" appear>
			<div class="quest_item" v-for="(quest, num) in questions" v-show="questIndex === num" :key="num">
				<div class="lines-wrapper">
					<div ref="lines1" class="lines1"></div>
					<div ref="lines2" class="lines2"></div>
				</div>

				<div class="quest_inner">
					<div class="quest_head">
						<div class="col">
							<p class="time">{{ formatVal(time.min) }}:{{ formatVal(time.sec) }}</p>
						</div>
						<div class="col">
							<p class="points">{{ points }}
								<starSvg class="star"></starSvg>
							</p>
						</div>
					</div>
					<div class="quest_body">
						<p class="progress">{{ (num + 1) }}</p>
						<p class="question">{{ quest.question }}</p>
						<img v-if="!!quest.image" :src="$store.getters['GET_URL_ROOT'] + quest.image" alt="">
					</div>
					<!--<div class="quest_footer one-row">-->
					<div class="quest_footer">
						<label class="radio_lbl" v-for=" (answer, index) in quest.answers" :key="index">
							<input type="radio" :name="'quest'+(num+1)" @change="chooseAnswer (quest.id, answer.id)">
							<span class="mark"></span>
							<p class="text">{{ answer.answer }}</p>
						</label>
					</div>
				</div>
			</div>
		</transition-group>
	</div>
</template>

<script>
	import {TweenMax} from 'gsap'
	import Helpers from '@/tools/Helpers'
	import star from '@/assets/svg/star.svg';

	export default {
		name: 'Test',
		data() {
			return {
				Helpers,
				questIndex: 0,
				points: 0,
				time: {
					min: 0,
					sec: 0
				}
			}
		},

		computed: {
			questions() {
				return this.$store.getters['GET_QUESTIONS'];
			}
		},

		mounted() {
			this.$store.commit('SET_POPUP', {
				name: 'Attention',
				cb: () => {
					this.$store.dispatch('START_TEST');
					this.tick();
				}
			});
			this.Helpers.ga().send('load', 'Страница теста');
			this.$store.commit('UPD_UI_SHOW', true);
		},

		methods: {
			formatVal(val) {
				return (parseInt(val) < 10) ? '0' + parseInt(val) : parseInt(val);
			},

			timer() {
				if (this.time.sec >= 59) {
					this.time.min += 1;
					this.time.sec = 0;
				} else {
					this.time.sec += 1;
				}
				this.tick();
			},
			tick() {
				this.timeout = setTimeout(this.timer, 1000);
			},
			resetTimer() {
				this.time = {
					min: 0,
					sec: 0
				}
			},
			stopTimer() {
				clearTimeout(this.timeout);
			},

			chooseAnswer(questionId, answerId) {
				let self = this;

				let question = this.questions.find((item) => {
					return item.id == questionId
				});
				Helpers.ga().send('click', 'question', question.question);
				let answer = question.answers.find((item) => {
					return item.id == answerId
				});
				Helpers.ga().send('click', 'answer', answer.answer);
				this.stopTimer();

				this.$store.dispatch('SEND_ANSWER', answerId).then((response) => {
					console.log(self.questIndex, self.questions.length);
					self.points += response.score;
					if (self.questIndex >= self.questions.length - 1) {
						self.completeTest();
					} else {
						self.questIndex += 1;
						self.resetTimer();
						self.tick();
					}
				});
			},

			completeTest() {
				this.$store.dispatch('END_TEST').then(() => {
					this.$router.push('/test/result');
				});
			}
		},
		components: {
			'starSvg': star,
			Helpers
		},
	}
</script>

<style lang="scss" scoped>
	.fadeIn-enter-active, .fadeIn-leave-active {
		opacity: 1;
		transition: opacity .5s;
	}

	.fadeIn-enter {
		opacity: 0;
	}

	.fadeIn-leave-to /* .fade-leave-active до версии 2.1.8 */
	{
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// TestInner.vue?9bdc27a0